(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[51112,99965],{

/***/ 35229:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.l = function FaCheck (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"}}]})(props);
};


/***/ }),

/***/ 15787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ GenIcon; }
});

// UNUSED EXPORTS: DefaultContext, IconBase, IconContext, IconsManifest

;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/iconsManifest.js
var IconsManifest = [
  {
    "id": "fa",
    "name": "Font Awesome",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/refactoringui/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  }
]
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/iconContext.js

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && react.createContext(DefaultContext);
;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/iconBase.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return react.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}

function GenIcon(data) {
  return function (props) {
    return react.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
        size = props.size,
        title = props.title,
        svgProps = __rest(props, ["attr", "size", "title"]);

    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + ' ' : '') + props.className;
    return react.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && react.createElement("title", null, title), props.children);
  };

  return IconContext !== undefined ? react.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/index.js




/***/ }),

/***/ 72603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useReservations; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9012);


function useReservations() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), data = ref[0], setData = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), error = ref2[0], setError = ref2[1];
    var checkLogin = function() {
        setLoading(true);
        (0,_components_api__WEBPACK_IMPORTED_MODULE_1__/* .AuthMyReservations */ .dQ)().then(function(response) {
            if (response.data.error) {
                setError(response.data.error);
                setData([]);
            } else {
                setData(response.data);
            }
            setLoading(false);
        }).catch(function(error) {
            setError(error);
            setLoading(false);
        });
    };
    return {
        loading: loading,
        error: error,
        data: data,
        setData: setData,
        setLoading: setLoading,
        checkLogin: checkLogin
    };
};


/***/ }),

/***/ 16543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var DefaultCurrencyFormat = function(_param) {
    var value = _param.value, Symbol = _param.Symbol, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "value",
        "Symbol"
    ]);
    var obj = {
        "\u20BA": "TRY",
        $: "USD",
        "\u20AC": "EUR",
        "\xa3": "GBP"
    };
    var formattedValue = new Intl.NumberFormat( false ? 0 : "tr-TR", {
        style: "currency",
        currency: obj[Symbol],
        minimumFractionDigits: 0
    }).format(value);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: formattedValue
    });
//return <></>;
//if (Symbol == "₺")
//  return (
//    <CurrencyFormat
//      value={value}
//      displayType={"text"}
//      thousandSeparator={"."}
//      decimalSeparator={","}
//      suffix={Symbol}
//      {...props}
//      renderText={(value) => <>{value}</>}
//    />
//  );
//return (
//  <CurrencyFormat
//    value={value}
//    displayType={"text"}
//    thousandSeparator={"."}
//    decimalSeparator={","}
//    prefix={Symbol}
//    {...props}
//    renderText={(value) => <>{value}</>}
//  />
//);
};
/* harmony default export */ __webpack_exports__["Z"] = (DefaultCurrencyFormat);


/***/ }),

/***/ 92235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);




var FancyBox = function(param) {
    var children = param.children, _options = param.options, options = _options === void 0 ? {} : _options, _delegate = param.delegate, delegate = _delegate === void 0 ? "[data-fancybox]" : _delegate;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), scriptsLoaded = ref[0], setScriptsLoaded = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var loadFancybox = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var link;
                return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            // Add CSS
                            if (!document.querySelector('link[href*="fancybox.css"]')) {
                                link = document.createElement("link");
                                link.rel = "stylesheet";
                                link.href = "https://cdn.jsdelivr.net/npm/@fancyapps/ui@5/dist/fancybox/fancybox.css";
                                document.head.appendChild(link);
                            }
                            if (document.querySelector('script[src*="fancybox.umd.js"]')) {
                                _ctx.next = 3;
                                break;
                            }
                            return _ctx.abrupt("return", new Promise(function(resolve) {
                                var script = document.createElement("script");
                                script.src = "https://cdn.jsdelivr.net/npm/@fancyapps/ui@5/dist/fancybox/fancybox.umd.js";
                                script.async = true;
                                script.onload = function() {
                                    return resolve(true);
                                };
                                document.body.appendChild(script);
                            }));
                        case 3:
                            return _ctx.abrupt("return", Promise.resolve(true));
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function loadFancybox() {
                return _ref.apply(this, arguments);
            };
        }();
        loadFancybox().then(function() {
            setScriptsLoaded(true);
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (scriptsLoaded && window.Fancybox) {
            // Initialize Fancybox
            window.Fancybox.bind(delegate, options);
            // Cleanup function
            return function() {
                window.Fancybox.destroy();
            };
        }
    }, [
        scriptsLoaded,
        delegate,
        options
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: children
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FancyBox);


/***/ }),

/***/ 71593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Blur; }
/* harmony export */ });
var Remote = function(param) {
    var src = param.src, width = param.width, quality = param.quality;
    if (width > 1920) width = 1920;
    return "".concat("https://cdn.villavillam.com.tr", "/uploads/").concat(width, "/").concat(src);
};
var Blur = function(src) {
    return "".concat("https://cdn.villavillam.com.tr", "/uploads/30/").concat(src);
};
/* harmony default export */ __webpack_exports__["Z"] = (Remote);


/***/ }),

/***/ 10559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Pages_Payment; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./auth/Reservations.js
var Reservations = __webpack_require__(72603);
// EXTERNAL MODULE: ./components/api.js
var api = __webpack_require__(9012);
// EXTERNAL MODULE: ./components/Loaders/ReservationsLoading.js
var ReservationsLoading = __webpack_require__(36289);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/yup-locales/dist/yup-locales.esm.js
var yup_locales_esm = __webpack_require__(18700);
// EXTERNAL MODULE: ./languages/tr.js
var tr = __webpack_require__(49323);
;// CONCATENATED MODULE: ./validations/PaymentShema.js



if (true) es/* setLocale */.i_(yup_locales_esm.tr); // en: Yup varsayilan (Ingilizce) mesajlari
var PaymentShema = es/* object */.Ry().shape({
    PaymentName: es/* string */.Z_().required(),
    cardNumber: es/* string */.Z_().length(19, tr/* language.cardNumberLength */.d.cardNumberLength).required(),
    month: es/* string */.Z_().matches(/0[1-9]|1[0-2]/).required(),
    year: es/* string */.Z_().matches(/^\d{2}$/).required(),
    cvv: es/* string */.Z_().matches(/^\d{3}$/).required(),
    sozlesme: es/* boolean */.O7().isTrue(),
    kvkk: es/* boolean */.O7().isTrue()
});

// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./components/Pages/Payment/Input.js
var Input = __webpack_require__(16719);
// EXTERNAL MODULE: ./components/Reservation/Contract.js
var Contract = __webpack_require__(57736);
// EXTERNAL MODULE: ./node_modules/axios/index.js + 40 modules
var axios = __webpack_require__(50196);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(22920);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/LoaderRemote.js
var LoaderRemote = __webpack_require__(71593);
// EXTERNAL MODULE: ./components/DefaultCurrencyFormat.js
var DefaultCurrencyFormat = __webpack_require__(16543);
// EXTERNAL MODULE: ./context/TranslationContext.js
var TranslationContext = __webpack_require__(73040);
;// CONCATENATED MODULE: ./components/Pages/Payment/Right.js






var Right = function(param) {
    var paymentDetails = param.paymentDetails;
    var ref = (0,TranslationContext/* useTranslation */.m)(), cleaningFee = ref.cleaningFee, PayByCreditCardRightTitle = ref.PayByCreditCardRightTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col lg:w-1/2 order-1 lg:order-2 items-center lg:items-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative w-full h-56 sm:w-[25.563rem] sm:h-[13.125rem] rounded mb-[1.188rem] overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: paymentDetails.resim,
                    objectFit: "cover",
                    objectPosition: "center",
                    loader: LoaderRemote/* default */.Z,
                    layout: "fill",
                    alt: paymentDetails.title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col mb-3 items-center lg:items-start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-bold text-[1.25rem] leading-7 text-[#333738] pb-[0.125rem]",
                        children: paymentDetails.baslik
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-[1.5rem] text-[#333738] leading-[2.063rem] font-bold",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCurrencyFormat/* default */.Z, {
                            value: paymentDetails.toplam_tutar,
                            Symbol: paymentDetails.Symbol
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center lg:items-start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-13 text-[#A2B2B8] font-medium leading-6",
                        children: PayByCreditCardRightTitle.replace("{night}", paymentDetails.gece)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "text-13 text-[#A2B2B8] font-medium leading-6",
                        children: [
                            cleaningFee,
                            " : ",
                            paymentDetails.temizlik
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "self-center lg:self-end mt-2 lg:mt-auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/images/visamaster.png",
                    width: 128,
                    height: 51
                })
            })
        ]
    });
};
/* harmony default export */ var Payment_Right = (Right);

// EXTERNAL MODULE: ./node_modules/react-dom/server.browser.js
var server_browser = __webpack_require__(97762);
;// CONCATENATED MODULE: ./components/Pages/Payment/Title.js





var Title = function(param) {
    var paymentDetails = param.paymentDetails;
    var ref = (0,TranslationContext/* useTranslation */.m)(), PayByCreditCardTitle = ref.PayByCreditCardTitle, PayByCreditCardCaption = ref.PayByCreditCardCaption;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col mb-9",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-15 font-bold text-text-rezervation-form leading-5",
                dangerouslySetInnerHTML: {
                    __html: PayByCreditCardTitle.replace("{price}", (0,server_browser/* renderToString */.Dq)(/*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCurrencyFormat/* default */.Z, {
                        value: paymentDetails.tutar,
                        Symbol: paymentDetails.Symbol
                    })))
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "sm:text-[1.875rem] text-25 font-bold leading-10 text[#333738]",
                children: PayByCreditCardCaption
            })
        ]
    });
};
/* harmony default export */ var Payment_Title = (Title);

// EXTERNAL MODULE: ./components/Pages/Payment/Installement.js
var Installement = __webpack_require__(71121);
// EXTERNAL MODULE: ./scripts/criteo.js
var criteo = __webpack_require__(77793);
;// CONCATENATED MODULE: ./icons/CardIcon.js


var CardIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        id: "Capa_1",
        enableBackground: "new 0 0 512 512",
        height: "512",
        width: "512",
        viewBox: "0 0 512 512",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m478.939 338.108-352.128 62.09c-21.756 3.836-42.502-10.691-46.338-32.446l-38.76-219.817c-3.836-21.756 10.691-42.502 32.446-46.338l352.128-62.09c21.756-3.836 42.502 10.691 46.338 32.446l38.76 219.817c3.837 21.755-10.69 42.502-32.446 46.338z",
                fill: "#3555a2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m426.288 39.506-176.064 31.045 52.651 298.602 176.064-31.045c21.756-3.836 36.283-24.582 32.446-46.338l-38.76-219.817c-3.835-21.756-24.581-36.283-46.337-32.447z",
                fill: "#1b3555"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m390 473.108h-350c-22.091 0-40-17.909-40-40v-217.718c0-22.091 17.909-40 40-40h350c22.091 0 40 17.909 40 40v217.718c0 22.091-17.909 40-40 40z",
                fill: "#53d8e3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m390 175.39h-175v297.718h175c22.091 0 40-17.909 40-40v-217.718c0-22.091-17.909-40-40-40z",
                fill: "#18a8c9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m0 243.44h430v68.05h-430z",
                fill: "#ecf6fd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m119.087 407.07h-68.05c-8.284 0-15 6.716-15 15s6.716 15 15 15h68.05c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
                fill: "#eaf6ff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m215 243.44h215v68.05h-215z",
                fill: "#d6e8fe"
            })
        ]
    });
};
/* harmony default export */ var icons_CardIcon = (CardIcon);

;// CONCATENATED MODULE: ./hooks/useTiko.js






var useTiko = function() {
    var router = (0,next_router.useRouter)();
    var TikoFormOnSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values, paymentDetails, id) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        values.VirtualPosId = paymentDetails.VirtualPosId;
                        values.price = paymentDetails.tutar;
                        values.rez_no = paymentDetails.id;
                        values.id = id;
                        _ctx.next = 6;
                        return CreatePaymentLink(localStorage.getItem("reservations_auth"), values).then(function(e) {
                            var ref;
                            if (e === null || e === void 0 ? void 0 : (ref = e.data) === null || ref === void 0 ? void 0 : ref.conversationId) {
                                var ref1;
                                router.push("https://api.villavillam.com.tr" + "/Tiko/CreateForm?conversationId=" + ((ref1 = e.data) === null || ref1 === void 0 ? void 0 : ref1.conversationId) + "&rez_no=" + id);
                            } else {
                                react_toastify_esm/* toast.error */.Am.error(e.data.error);
                            }
                        });
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function TikoFormOnSubmit(values, paymentDetails, id) {
            return _ref.apply(this, arguments);
        };
    }();
    var TikoInstallment = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return Installment(values).then(function(e) {
                            return e.data;
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function TikoInstallment(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var CreatePaymentLink = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(token, formData) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", api/* server.post */.fw.post("/Tiko/CreateForm?token=" + token, formData));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function CreatePaymentLink(token, formData) {
            return _ref.apply(this, arguments);
        };
    }();
    var Installment = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(formData) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", api/* server.post */.fw.post("/Tiko/Installment", formData));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function Installment(formData) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        TikoFormOnSubmit: TikoFormOnSubmit,
        TikoInstallment: TikoInstallment
    };
};
/* harmony default export */ var hooks_useTiko = (useTiko);

;// CONCATENATED MODULE: ./components/CountDown.js



var Countdown = function(param) {
    var expiredOn = param.expiredOn, currentDate = param.currentDate, _className = param.className, className = _className === void 0 ? "" : _className;
    var ref = (0,TranslationContext/* useTranslation */.m)(), timeAlmostUp = ref.timeAlmostUp, paymentTime = ref.paymentTime, timeLeftToComplete = ref.timeLeftToComplete, dayShort = ref.dayShort, hoursLabel = ref.hoursLabel, minutesLabel = ref.minutesLabel, secondsLabel = ref.secondsLabel;
    var ref1 = (0,react.useState)({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    }), timeLeft = ref1[0], setTimeLeft = ref1[1];
    var ref2 = (0,react.useState)(false), isLowTime = ref2[0], setIsLowTime = ref2[1];
    (0,react.useEffect)(function() {
        var expiryDate = new Date(expiredOn);
        var calculateTimeLeft = function() {
            var now = new Date();
            var difference = expiryDate - now;
            if (difference <= 0) {
                return {
                    days: 0,
                    hours: 0,
                    minutes: 0,
                    seconds: 0
                };
            }
            // Son 5 dakika kala uyarı modu
            if (difference < 5 * 60 * 1000) {
                setIsLowTime(true);
            } else {
                setIsLowTime(false);
            }
            return {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor(difference / (1000 * 60 * 60) % 24),
                minutes: Math.floor(difference / (1000 * 60) % 60),
                seconds: Math.floor(difference / 1000 % 60)
            };
        };
        // Initial calculation
        setTimeLeft(calculateTimeLeft());
        var interval = setInterval(function() {
            var t = calculateTimeLeft();
            setTimeLeft(t);
            if (t.days === 0 && t.hours === 0 && t.minutes === 0 && t.seconds === 0) {
                clearInterval(interval);
            }
        }, 1000);
        return function() {
            return clearInterval(interval);
        };
    }, [
        expiredOn
    ]);
    var formatNumber = function(num) {
        return num < 10 ? "0".concat(num) : num;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "\n        @keyframes swing {\n          0% { transform: rotate(0deg); }\n          25% { transform: rotate(15deg); }\n          50% { transform: rotate(0deg); }\n          75% { transform: rotate(-15deg); }\n          100% { transform: rotate(0deg); }\n        }\n        @keyframes popIn {\n          0% { transform: scale(0.8); opacity: 0; }\n          100% { transform: scale(1); opacity: 1; }\n        }\n        @keyframes pulseBorder {\n          0% { box-shadow: 0 0 0 0 rgba(234, 88, 12, 0.4); }\n          70% { box-shadow: 0 0 0 6px rgba(234, 88, 12, 0); }\n          100% { box-shadow: 0 0 0 0 rgba(234, 88, 12, 0); }\n        }\n        @keyframes gradientFlow {\n          0% { background-position: 0% 50%; }\n          50% { background-position: 100% 50%; }\n          100% { background-position: 0% 50%; }\n        }\n        .icon-swing {\n          animation: swing 2s ease-in-out infinite;\n          transform-origin: top center;\n        }\n        .num-pop {\n          animation: popIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n        }\n        .border-pulse {\n          animation: pulseBorder 2s infinite;\n        }\n        .gradient-bg {\n          background: linear-gradient(-45deg, #fff7ed, #ffedd5, #fee2e2);\n          background-size: 200% 200%;\n          animation: gradientFlow 5s ease infinite;\n        }\n      "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col md:flex-row items-center justify-between w-full p-5 mb-6 border rounded-2xl shadow-md overflow-hidden relative ".concat(isLowTime ? "border-red-200" : "border-orange-200", " gradient-bg ").concat(className),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-orange-300 rounded-full opacity-10 blur-xl"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute bottom-0 left-0 -mb-4 -ml-4 w-24 h-24 bg-red-300 rounded-full opacity-10 blur-xl"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-4 mb-6 md:mb-0 relative z-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "p-3 rounded-xl shadow-sm ".concat(isLowTime ? "bg-red-100 text-red-600" : "bg-orange-100 text-orange-600"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    className: "w-7 h-7 icon-swing",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: "2",
                                        d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-extrabold text-lg md:text-xl tracking-tight ".concat(isLowTime ? "text-red-800" : "text-orange-900"),
                                        children: isLowTime ? timeAlmostUp : paymentTime
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-xs font-medium ".concat(isLowTime ? "text-red-600" : "text-orange-600/80"),
                                        children: timeLeftToComplete
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-3 relative z-10",
                        children: [
                            timeLeft.days > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col items-center group",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "relative bg-white/80 backdrop-blur-sm px-4 py-3 rounded-xl border border-orange-100 shadow-sm min-w-[70px] flex justify-center transition-transform hover:-translate-y-1",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-3xl font-black text-orange-600 font-mono leading-none num-pop",
                                                        children: formatNumber(timeLeft.days)
                                                    }, timeLeft.days),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "absolute inset-0 rounded-xl ring-1 ring-inset ring-black/5"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-[11px] font-bold text-orange-400 uppercase tracking-widest mt-2",
                                                children: dayShort
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-orange-300 font-black text-2xl pb-6 animate-pulse",
                                        children: ":"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col items-center group",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "relative bg-white/80 backdrop-blur-sm px-4 py-3 rounded-xl border border-orange-100 shadow-sm min-w-[70px] flex justify-center transition-transform hover:-translate-y-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-3xl font-black text-orange-600 font-mono leading-none num-pop",
                                                children: formatNumber(timeLeft.hours)
                                            }, timeLeft.hours),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute inset-0 rounded-xl ring-1 ring-inset ring-black/5"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[11px] font-bold text-orange-400 uppercase tracking-widest mt-2",
                                        children: hoursLabel
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-orange-300 font-black text-2xl pb-6 animate-pulse",
                                children: ":"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col items-center group",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "relative bg-white/80 backdrop-blur-sm px-4 py-3 rounded-xl border border-orange-100 shadow-sm min-w-[70px] flex justify-center transition-transform hover:-translate-y-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-3xl font-black text-orange-600 font-mono leading-none num-pop",
                                                children: formatNumber(timeLeft.minutes)
                                            }, timeLeft.minutes),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute inset-0 rounded-xl ring-1 ring-inset ring-black/5"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[11px] font-bold text-orange-400 uppercase tracking-widest mt-2",
                                        children: minutesLabel
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-orange-300 font-black text-2xl pb-6 animate-pulse",
                                children: ":"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col items-center group",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "relative bg-white/90 backdrop-blur-sm px-4 py-3 rounded-xl border shadow-sm min-w-[70px] flex justify-center transition-transform hover:-translate-y-1 ".concat(isLowTime ? "border-red-200 border-pulse" : "border-orange-100"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-3xl font-black font-mono leading-none num-pop ".concat(isLowTime ? "text-red-600" : "text-orange-600"),
                                                children: formatNumber(timeLeft.seconds)
                                            }, timeLeft.seconds),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute inset-0 rounded-xl ring-1 ring-inset ring-black/5"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[11px] font-bold uppercase tracking-widest mt-2 ".concat(isLowTime ? "text-red-400" : "text-orange-400"),
                                        children: secondsLabel
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CountDown = (Countdown);

;// CONCATENATED MODULE: ./components/Pages/Payment.js






















// import { b64_sha1 } from "../../helper/hex_sha1";
// import { on } from "form-data";


var Payment = function(param) {
    var ssr = param.ssr;
    var ref = (0,TranslationContext/* useTranslation */.m)(), PayByCreditCardFormName = ref.PayByCreditCardFormName, PayByCreditCardFormCardNumber = ref.PayByCreditCardFormCardNumber, PayByCreditCardFormSubmit = ref.PayByCreditCardFormSubmit, dateMonth = ref.dateMonth, dateYear = ref.dateYear, contract1 = ref.contract1, contract2 = ref.contract2, PaymentAuthRequired = ref.PaymentAuthRequired, reservations = ref.reservations, login = ref.login, paymentStatusChecking = ref.paymentStatusChecking, closeWindowAfterPayment = ref.closeWindowAfterPayment, clickToPay = ref.clickToPay, installments369 = ref.installments369, bankRatesApply = ref.bankRatesApply;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,Reservations/* default */.Z)(), data = ref1.data, error = ref1.error, loading = ref1.loading, checkLogin = ref1.checkLogin, setLoading = ref1.setLoading;
    var ref2 = hooks_useTiko(), TikoFormOnSubmit = ref2.TikoFormOnSubmit, TikoInstallment = ref2.TikoInstallment;
    var ref3 = (0,react.useState)(false), paymentError = ref3[0], setPaymentError = ref3[1];
    var ref4 = (0,react.useState)(false), paymentDetails = ref4[0], setPaymentDetails = ref4[1];
    var ref5 = (0,react.useState)(""), cardNumberListen = ref5[0], setCardNumberListen = ref5[1];
    var ref6 = (0,react.useState)([]), installement = ref6[0], setInstallement = ref6[1];
    var ref7 = (0,react.useState)(false), paymentLoading = ref7[0], setPaymentLoading = ref7[1];
    var ref8 = (0,react.useState)(false), formData = ref8[0], setFormData = ref8[1];
    var ref9 = (0,react.useState)({
        open: false,
        src: "",
        onClose: null
    }), iframeModal = ref9[0], setIframeModal = ref9[1];
    (0,react.useEffect)(function() {
        var ref;
        checkLogin();
        if ((ref = router.query) === null || ref === void 0 ? void 0 : ref.conversationId) {
            var ref1;
            setPaymentLoading(true);
            (0,api/* CheckValletPaymentStatus */.Vk)((ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.conversationId).then(function(e) {
                if (e.data.status) {
                    criteo/* payment */.mG(paymentDetails.email, paymentDetails.tarih, paymentDetails.tarih2, paymentDetails.yetiskin, paymentDetails.cocuk, paymentDetails.id, paymentDetails.evid, paymentDetails.tutar);
                    router.push(reservations.url);
                } else react_toastify_esm/* toast.error */.Am.error(e.data.response.bankMessage);
            }).finally(function() {
                return setPaymentLoading(false);
            });
        }
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        if ((router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.authKey) || router.query.token) {
            (0,api/* AuthLogin */.rE)(null, null, router.query.authKey, router.query.token).then(function(response) {
                if (response.data.error) {
                    localStorage.removeItem("reservations_auth");
                    react_toastify_esm/* toast.error */.Am.error(response.data.error);
                } else {
                    localStorage.setItem("reservations_auth", response.data.token);
                    checkLogin();
                }
            }).catch(function(error) {
                react_toastify_esm/* toast.error */.Am.error(error.message);
            });
        } else {
            checkLogin();
        }
    }, []);
    (0,react.useEffect)(function() {
        if (data === null || data === void 0 ? void 0 : data.IsLogin) {
            (0,api/* GetPaymentData */.ji)(data.IsLogin.Token, router.query["_"]).then(function(e) {
                if (e.data.error) {
                    setPaymentError(e.data.error);
                } else {
                    setPaymentError(false);
                    setPaymentDetails(e.data.data);
                }
            }).catch(function(e) {
                return setPaymentError(e.message);
            });
        }
    }, [
        data
    ]);
    var DetectCardNumber = function() {
        var values = (0,formik_esm/* useFormikContext */.u6)().values;
        (0,react.useEffect)(function() {
            if (values.cardNumber.length >= 7) setCardNumberListen(values.cardNumber.slice(0, 7).replace("-", ""));
            else setCardNumberListen("");
        }, [
            values
        ]);
        return null;
    };
    (0,react.useEffect)(function() {
        if (cardNumberListen.length == 6 && paymentDetails) {
            if (paymentDetails.VirtualPosId == 5) {
                TikoInstallment({
                    binNumber: cardNumberListen,
                    price: paymentDetails.tutar
                }).then(function(e) {
                    if (e.Result) {
                        setInstallement(e.Result.map(function(e) {
                            return {
                                installmentNumber: e.Installment,
                                installmentPrice: e.AmountPerMonth,
                                totalPrice: e.Amount
                            };
                        }));
                    }
                });
            } else {
                axios/* default.post */.ZP.post("/api/InstallmentInfo", {
                    binNumber: cardNumberListen,
                    price: paymentDetails.tutar
                }).then(function(e) {
                    if (e.data.status == "success") {
                        setInstallement(e.data.installmentDetails[0].installmentPrices);
                    } else {
                        setInstallement([]);
                    }
                });
            }
        } else setInstallement([]);
    }, [
        cardNumberListen,
        paymentDetails
    ]);
    var FormOnSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values, actions) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (paymentDetails.VirtualPosId == 3 && values.installement == 1) {
                            paymentDetails.VirtualPosId = 4;
                        }
                        if (paymentDetails.VirtualPosId == 3) // Iyzico
                        axios/* default.post */.ZP.post("/api/Payment?token=" + data.IsLogin.Token, (0,_object_spread/* default */.Z)({
                            _: router.query["_"],
                            ip: paymentDetails.ip
                        }, values)).then(function(result) {
                            if (result.data.success) {
                                setIframeModal({
                                    open: true,
                                    src: "/api/PaymentForm?_=" + router.query["_"],
                                    onClose: function() {
                                        (0,api/* CheckPaymentStatus */._l)(router.query._).then(function(e) {
                                            if (e.data.status == "success") {
                                                criteo/* payment */.mG(paymentDetails.email, paymentDetails.tarih, paymentDetails.tarih2, paymentDetails.yetiskin, paymentDetails.cocuk, paymentDetails.id, paymentDetails.evid, paymentDetails.tutar);
                                                router.push(reservations.url);
                                            }
                                        });
                                    }
                                });
                            } else {
                                react_toastify_esm/* toast.error */.Am.error(result.data.error);
                            }
                        }).finally(function() {
                            actions.setSubmitting(false);
                        });
                        if (!(paymentDetails.VirtualPosId == 4)) {
                            _ctx.next = 11;
                            break;
                        }
                        //HalkBank
                        values.VirtualPosId = paymentDetails.VirtualPosId;
                        values.price = paymentDetails.tutar;
                        values.rez_no = paymentDetails.id;
                        _ctx.next = 8;
                        return (0,api/* CreateHashData */.Rw)(values).then(function(e) {
                            var data = e.data.data;
                            var random = Math.floor(Math.random() * 1000000000);
                            var formObj = (0,_object_spread/* default */.Z)({
                                clientid: data.ClientId,
                                amount: data.Amount,
                                okurl: data.OkUrl,
                                failUrl: data.FailUrl,
                                TranType: data.Auth,
                                callbackUrl: data.callback,
                                currency: paymentDetails.PosCode,
                                rnd: random,
                                storetype: "3D_PAY",
                                hashAlgorithm: "ver3",
                                lang: "tr",
                                BillToName: values.PaymentName,
                                BillToCompany: values.PaymentName,
                                SID: "id_" + random,
                                sipBil: random,
                                odeme_tipi: "Kredi Kart\u0131",
                                tampara: "",
                                pan: values.cardNumber.replaceAll("-", ""),
                                Ecom_Payment_Card_ExpDate_Month: values.month,
                                Ecom_Payment_Card_ExpDate_Year: values.year,
                                cv2: values.cvv,
                                Instalment: data.Installment,
                                isim: paymentDetails.musteri,
                                email: paymentDetails.email,
                                telefon: paymentDetails.telefon,
                                mesaj: "",
                                VirtualPosId: values.VirtualPosId,
                                tutar: parseInt(data.Amount),
                                gonder: "\xd6demeyi Yap"
                            }, values);
                            delete formObj.cvv;
                            delete formObj.cardNumber;
                            delete formObj.PaymentName;
                            delete formObj.month;
                            delete formObj.year;
                            delete formObj.price;
                            delete formObj.installement;
                            delete formObj.kvkk;
                            axios/* default.post */.ZP.post("https://api.villavillam.com.tr" + "/CreateForm", formObj).then(function(e) {
                                setIframeModal({
                                    open: true,
                                    src: "https://api.villavillam.com.tr" + "/CreateForm?rez_no=" + paymentDetails.id,
                                    onClose: function() {
                                        var toastId = react_toastify_esm/* toast.loading */.Am.loading(paymentStatusChecking);
                                        (0,api/* GetPaymentStatus */.C2)(formObj.sipBil + "-" + formObj.rez_no).then(function(e) {
                                            var r = JSON.parse(e.data.data.Response);
                                            if ((r === null || r === void 0 ? void 0 : r.ProcReturnCode) == "00") {
                                                criteo/* payment */.mG(paymentDetails.email, paymentDetails.tarih, paymentDetails.tarih2, paymentDetails.yetiskin, paymentDetails.cocuk, paymentDetails.id, paymentDetails.evid, paymentDetails.tutar);
                                                router.push(reservations.url);
                                            }
                                            if (r.mdErrorMsg && (r === null || r === void 0 ? void 0 : r.ProcReturnCode) !== "00") {
                                                react_toastify_esm/* toast.error */.Am.error(r.mdErrorMsg + ((r === null || r === void 0 ? void 0 : r.ErrMsg) ? r === null || r === void 0 ? void 0 : r.ErrMsg : ""));
                                            }
                                        }).finally(function() {
                                            react_toastify_esm/* toast.dismiss */.Am.dismiss(toastId);
                                        });
                                    }
                                });
                            });
                        });
                    case 8:
                        actions.setSubmitting(false);
                        _ctx.next = 15;
                        break;
                    case 11:
                        if (!(paymentDetails.VirtualPosId == 5)) {
                            _ctx.next = 15;
                            break;
                        }
                        _ctx.next = 14;
                        return TikoFormOnSubmit(values, paymentDetails, router.query["_"]);
                    case 14:
                        actions.setSubmitting(false);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function FormOnSubmit(values, actions) {
            return _ref.apply(this, arguments);
        };
    }();
    var HandleClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setPaymentLoading(true);
                        _ctx.next = 3;
                        return (0,api/* CreatePaymentLink */.yr)(data.IsLogin.Token, router.query["_"]).then(function(result) {
                            var data = result.data;
                            if (data.Response.status == "success") {
                                router.replace(data.Response.payment_page_url);
                                (0,api/* CheckValletPaymentStatus */.Vk)(data.Response.conversationId).then(function(e) {
                                    var ref;
                                    if ((e === null || e === void 0 ? void 0 : (ref = e.data) === null || ref === void 0 ? void 0 : ref.status) == true) {
                                        criteo/* payment */.mG(paymentDetails.email, paymentDetails.tarih, paymentDetails.tarih2, paymentDetails.yetiskin, paymentDetails.cocuk, paymentDetails.id, paymentDetails.evid, paymentDetails.tutar);
                                        router.push(reservations.url);
                                    }
                                });
                            }
                            if (data.error) {
                                react_toastify_esm/* toast.error */.Am.error(data.error);
                            }
                        }).finally(function() {
                            return setPaymentLoading(false);
                        });
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function HandleClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var closeIframeModal = function() {
        var onClose = iframeModal.onClose;
        setIframeModal({
            open: false,
            src: "",
            onClose: null
        });
        if (onClose) onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            iframeModal.open && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fixed inset-0 z-[9999] flex items-center justify-center",
                style: {
                    backgroundColor: "rgba(0,0,0,0.7)"
                },
                onClick: function(e) {
                    if (e.target === e.currentTarget) closeIframeModal();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative bg-white rounded-xl overflow-hidden flex flex-col",
                    style: {
                        width: "500px",
                        height: "90vh",
                        maxWidth: "95vw"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between px-4 py-3 shrink-0 border-b border-gray-100",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-sm text-gray-500",
                                    children: closeWindowAfterPayment
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: closeIframeModal,
                                    className: "ml-4 shrink-0 w-9 h-9 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 text-gray-600 hover:text-gray-900 text-xl font-bold leading-none transition-colors",
                                    children: "\xd7"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            src: iframeModal.src,
                            className: "w-full flex-1 border-0",
                            allow: "fullscreen"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lg:h-[calc(100vh-96px)] pb-16 lg:pb-0 overflow-hidden bg-brand-white bg-opacity-50 flex items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container flex items-center justify-center ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:w-[64.375rem] w-full min-h-[500px] bg-white rounded-[1.875rem] lg:py-[3.688rem] sm:py-8 py-4 lg:px-[3.125rem] sm:px-8 px-4 lg:my-0 my-4",
                        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ReservationsLoading/* default */.Z, {}) : data && data.IsLogin != false && !paymentError && paymentDetails ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CountDown, {
                                    expiredOn: paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.saat,
                                    currentDate: paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.CurrentDate,
                                    className: "!rounded-lg"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex lg:gap-x-[3.313rem] gap-y-7 flex-col lg:flex-row",
                                    children: [
                                        (paymentDetails.VirtualPosId == "1" || paymentDetails.VirtualPosId == "2") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-full flex flex-col content-center justify-center min-h-[500px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex flex-col items-center w-full border py-5 cursor-pointer",
                                                onClick: HandleClick,
                                                children: paymentLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ReservationsLoading/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_CardIcon, {
                                                            className: "w-10 h-10"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "font-bold text-25 text-primary",
                                                            children: clickToPay
                                                        }),
                                                        paymentDetails.VirtualPosId == "2" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: installments369
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: bankRatesApply
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        (paymentDetails.VirtualPosId == "3" || paymentDetails.VirtualPosId == "5" || paymentDetails.VirtualPosId == "4") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "lg:w-1/2 order-2 lg:order-1",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Payment_Title, {
                                                            paymentDetails: paymentDetails
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                                                            initialValues: {
                                                                PaymentName: "",
                                                                cardNumber: "",
                                                                month: "",
                                                                year: "",
                                                                cvv: "",
                                                                sozlesme: false,
                                                                kvkk: false,
                                                                installement: 1
                                                            },
                                                            validationSchema: PaymentShema,
                                                            onSubmit: FormOnSubmit,
                                                            children: function(props) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                                                    onSubmit: props.handleSubmit,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "relative z-0 mb-6 w-full group",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                                                name: "PaymentName",
                                                                                placeholder: " ",
                                                                                label: PayByCreditCardFormName
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "relative z-0 mb-6 w-full group",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                                                    name: "cardNumber",
                                                                                    placeholder: "",
                                                                                    label: PayByCreditCardFormCardNumber,
                                                                                    mask: "____-____-____-____",
                                                                                    replacement: {
                                                                                        _: /\d/
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Installement/* default */.Z, {
                                                                                    installement: installement,
                                                                                    handleChange: props.handleChange,
                                                                                    paymentDetails: paymentDetails
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "grid grid-cols-3 gap-x-4",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "relative z-0 mb-6 w-full group",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                                                        name: "month",
                                                                                        placeholder: "- -",
                                                                                        label: dateMonth,
                                                                                        mask: "__",
                                                                                        replacement: {
                                                                                            _: /\d/
                                                                                        }
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "relative z-0 mb-6 w-full group",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                                                        name: "year",
                                                                                        placeholder: "- -",
                                                                                        label: dateYear,
                                                                                        mask: "__",
                                                                                        replacement: {
                                                                                            _: /\d/
                                                                                        }
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "relative z-0 mb-6 w-full group",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                                                        name: "cvv",
                                                                                        placeholder: "- - -",
                                                                                        label: "CVC",
                                                                                        mask: "___",
                                                                                        replacement: {
                                                                                            _: /\d/
                                                                                        }
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "flex flex-col sm:flex-row items-center justify-center sm:justify-between flex-wrap ",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "flex flex-col gap-2",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Contract/* default */.Z, {
                                                                                            name: "sozlesme",
                                                                                            text: contract1,
                                                                                            content: ssr.result.sozlesme.icerik
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Contract/* default */.Z, {
                                                                                            name: "kvkk",
                                                                                            text: contract2,
                                                                                            content: ssr.result.kvkk.icerik
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                    type: "submit",
                                                                                    disabled: props.isSubmitting || !props.isValid || !props.dirty,
                                                                                    className: "mt-3 text-white md:px-[2.75rem] px-8 md:py-[1.188rem] py-3 duration-200 bg-product-type-color hover:bg-opacity-80 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm text-center disabled:opacity-60 disabled:cursor-not-allowed",
                                                                                    children: PayByCreditCardFormSubmit
                                                                                })
                                                                            ]
                                                                        }),
                                                                        paymentDetails.VirtualPosId == 3 || paymentDetails.VirtualPosId == 5 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DetectCardNumber, {}) : null
                                                                    ]
                                                                });
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Payment_Right, {
                                                    paymentDetails: paymentDetails
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }) : paymentError ? /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: "flex items-center h-full sm:p-16",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container flex flex-col items-center justify-center px-5 mx-auto my-8 space-y-3 text-center sm:max-w-md",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "",
                                    children: paymentError
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: "flex items-center h-full sm:p-16",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "container flex flex-col items-center justify-center px-5 mx-auto my-8 space-y-3 text-center sm:max-w-md",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "",
                                        children: PaymentAuthRequired
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: reservations.url,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            rel: "noopener noreferrer",
                                            className: "px-4 py-1 rounded bg-brand-color-primary text-white text-sm",
                                            children: login
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Pages_Payment = (Payment);


/***/ }),

/***/ 16719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82175);
/* harmony import */ var react_mask_field__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18935);








"use client";
var Input = function(_param) {
    var label = _param.label, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "label"
    ]);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,formik__WEBPACK_IMPORTED_MODULE_2__/* .useField */ .U$)(props), 3), field = ref[0], meta = ref[1], helpers = ref[2];
    // useEffect(() => {
    //   if (field.value) helpers.setTouched(true);
    // }, [field.value]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            props.mask ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_mask_field__WEBPACK_IMPORTED_MODULE_3__/* .MaskField */ .V, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                className: "border-gray-300 block rounded-md py-5 px-6 w-full text-[0.875rem]  bg-transparent border  appearance-none   focus:outline-none focus:ring-0 focus:border-brand-color-secondary peer " + (!meta.error && field.value ? "border-green-500 focus:!border-green-500" : "") + (meta.error && field.value ? " border-red-500 focus:!border-red-500" : " ")
            }, field, props), {
                id: props.id || props.name
            })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                className: "border-gray-300 block rounded-md py-5 px-6 w-full text-[0.875rem]  bg-transparent border  appearance-none   focus:outline-none focus:ring-0 focus:border-brand-color-secondary peer " + (!meta.error && meta.touched ? "border-green-500 focus:border-green-500" : "") + (meta.error && meta.touched ? " border-red-500 focus:border-red-500" : " ")
            }, field, props), {
                id: props.id || props.name
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                htmlFor: props.name,
                className: "peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-brand-color-secondary duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3 left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-brand-color-secondary peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6",
                children: label
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 71121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _DefaultCurrencyFormat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16543);
/* harmony import */ var _context_TranslationContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73040);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82175);





var Installement = function(param) {
    var handleChange = param.handleChange, installement = param.installement, paymentDetails = param.paymentDetails;
    var formik = (0,formik__WEBPACK_IMPORTED_MODULE_4__/* .useFormikContext */ .u6)();
    var ref = (0,_context_TranslationContext__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .m)(), installementFull = ref.installementFull, installementText = ref.installement;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (installement.length <= 1) {
            formik.setFieldValue("installement", 1);
        }
    }, [
        installement
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("select", {
        name: "installement",
        onChange: handleChange,
        className: "mt-6 bg-gray-50 border outline-none focus:border-brand-color-secondary border-gray-300 text-gray-900 text-sm rounded-lg   w-full p-2.5 transform-gpu transition-all origin-top  " + (installement.length > 1 ? "scale-y-1 " : "scale-y-0 hidden"),
        children: installement.map(function(e, l) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: e.installmentNumber,
                children: e.installmentNumber == "1" || e.installmentNumber == "0" ? installementFull : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        e.installmentNumber,
                        " ",
                        installementText,
                        " x",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DefaultCurrencyFormat__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            Symbol: paymentDetails.Symbol,
                            value: e.installmentPrice,
                            decimalScale: 2
                        }),
                        " ",
                        "=",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DefaultCurrencyFormat__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            Symbol: paymentDetails.Symbol,
                            value: e.totalPrice,
                            decimalScale: 2
                        })
                    ]
                })
            }, "installement_" + l);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Installement);


/***/ }),

/***/ 57736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Fancybox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92235);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82175);
/* harmony import */ var _react_icons_all_files_fa_FaCheck__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35229);
/* harmony import */ var _context_TranslationContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73040);
/* harmony import */ var react_dom_server__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97762);











var Contract = function(_param) {
    var text = _param.text, content = _param.content, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "text",
        "content"
    ]);
    var contractText = (0,_context_TranslationContext__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .m)().contractText;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,formik__WEBPACK_IMPORTED_MODULE_3__/* .useField */ .U$)(props), 3), field = ref[0], meta = ref[1], helpers = ref[2];
    var El = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            "data-fancybox": "dialog",
            "data-src": "#" + props.name + "-content",
            className: "font-bold",
            children: text
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Fancybox__WEBPACK_IMPORTED_MODULE_2__["default"], {
        options: {
            infinite: false
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative inline-block w-full sm:w-auto",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                        type: "checkbox"
                    }, props, field), {
                        id: props.name,
                        onChange: function(e) {
                            helpers.setValue(e.target.checked);
                        },
                        className: "w-0 h-0 absolute peer"
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                        htmlFor: props.name,
                        className: "text-13 text-black pl-7 py-2 cursor-pointer",
                        dangerouslySetInnerHTML: {
                            __html: contractText.replace(/\{contractName\}/g, (0,react_dom_server__WEBPACK_IMPORTED_MODULE_5__/* .renderToString */ .Dq)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(El, {})))
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "w-5 h-5 pointer-events-none rounded-sm border-2 transition-colors border-brand-gray-8 absolute left-0 top-0 mt-1 peer-checked:bg-brand-gray-8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fa_FaCheck__WEBPACK_IMPORTED_MODULE_10__/* .FaCheck */ .l, {
                        size: 12,
                        className: "absolute left-1 top-2 opacity-0 peer-checked:opacity-100 pointer-events-none"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: props.name + "-content",
                className: "hidden max-w-[90%] break-words",
                dangerouslySetInnerHTML: {
                    __html: content
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Contract);


/***/ }),

/***/ 18935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ y; }
/* harmony export */ });
/* unused harmony export useMask */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */var o=function(e,r){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,r){e.__proto__=r}||function(e,r){for(var t in r)Object.prototype.hasOwnProperty.call(r,t)&&(e[t]=r[t])})(e,r)};var c=function(){return(c=Object.assign||function(e){for(var r,t=1,n=arguments.length;t<n;t++)for(var a in r=arguments[t])Object.prototype.hasOwnProperty.call(r,a)&&(e[a]=r[a]);return e}).apply(this,arguments)};function i(e){var r;return"string"==typeof e?((r={})[e]=/./,r):e}function s(e){var r=e.value,t=e.replaceableSymbols,n=e.replacement,a=e.separate,u=t;return r.split("").reduce((function(e,r){var t,l=Object.prototype.hasOwnProperty.call(n,r),o=null===(t=n[u[0]])||void 0===t?void 0:t.test(r);return(a?l||o:!l&&o)?(u=u.slice(1),e+r):e}),"")}function p(e){var r=e.maskingData,t=e.inputType,n=e.selectionRange,a=e.added,u=r.ast,l=r.mask,o=r.replacement,c=r.separate,i=a,p="",d="";u.forEach((function(e,r){var t=e.symbol,a=e.own;(c?"change"===a||"replacement"===a:"change"===a)&&(r<n.start?p+=t:r>=n.end&&(d+=t))}));var v=l.split("").reduce((function(e,r){return Object.prototype.hasOwnProperty.call(o,r)?e+r:e}),"");if(p&&(p=s({value:p,replaceableSymbols:v,replacement:o,separate:c})),v=v.slice(p.length),i&&(i=s({value:i,replaceableSymbols:v,replacement:o,separate:!1})),c){var f=l.split("").reduce((function(e,r,t){var a=t>=n.start&&t<n.end,u=Object.prototype.hasOwnProperty.call(o,r);return a&&u?e+r:e}),""),h=f.length-i.length;h<0?d=d.slice(-h):h>0&&(d=f.slice(-h)+d)}return v=v.slice(i.length),d&&(d=s({value:d,replaceableSymbols:v,replacement:o,separate:c})),{unmaskedValue:p+i+d,added:i,beforeRange:p,afterRange:d,inputType:t}}function d(e,r,t){return e.split("").findIndex((function(e,n){var a=Object.prototype.hasOwnProperty.call(r,e);return n>=(t||0)&&a}))}function v(e,r,t){var n=["[","]","\\","/","^","$",".","|","?","*","+","(",")","{","}"];return e.split("").reduce((function(e,a,u,l){var o=e+(Object.prototype.hasOwnProperty.call(r,a)?(t?"(?!"+a+")":"")+r[a].toString().slice(1,-1):n.includes(a)?"\\"+a:a);return u+1===l.length?o+"$":o}),"^")}function f(e){var r=e.initialValue,t=e.unmaskedValue,n=e.mask,a=e.replacement,u=e.showMask,l=e.separate,o=null!=r?r:function(e,r,t){var n=0;return r.split("").reduce((function(r,a){var u=Object.prototype.hasOwnProperty.call(t,a),l=void 0!==e[n];return r+(u&&l?e[n++]:a)}),"")}(t,n,a),c=function(e,r,t){return e.split("").map((function(e,n){return{symbol:e,index:n,own:Object.prototype.hasOwnProperty.call(t,e)?"replacement":e===r[n]?"mask":"change"}}))}(o,n,a);if(void 0===r&&!u)if(void 0===c.find((function(e){return"change"===e.own})))o="";else{var i=function(e,r,t){if(t||2===arguments.length)for(var n,a=0,u=r.length;a<u;a++)!n&&a in r||(n||(n=Array.prototype.slice.call(r,0,a)),n[a]=r[a]);return e.concat(n||r)}([],c).reverse().find((function(e){return"change"===e.own})),s=void 0!==i?i.index+1:0;o=o.slice(0,s)}var p=v(n,a),d=v(n,a,!0);return{maskedValue:o,ast:c,isValid:new RegExp(d).test(o),mask:n,replacement:a,showMask:u,separate:l,pattern:p}}var h=function(e){function r(r){var t=e.call(this,r)||this;return t.name="SyntheticChangeError",t}return function(e,r){if("function"!=typeof r&&null!==r)throw new TypeError("Class extends value "+String(r)+" is not a constructor or null");function t(){this.constructor=e}o(e,r),e.prototype=null===r?Object.create(r):(t.prototype=r.prototype,new t)}(r,e),r}(Error);function m(e){var l,o=e.mask,c=e.replacement,s=e.showMask,v=e.separate,m=e.modify,y=e.onMasking,k=null!=o?o:"",g=i(null!=c?c:{}),w=null!=s&&s,b=null!=v&&v,O=JSON.stringify(g,(function(e,r){return r instanceof RegExp?r.toString():r})),V=(0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null),j=(0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null),E=(0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null),S=(0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)({cachedRequestID:-1,requestID:-1,start:0,end:0}),P=(0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(!0),M=function(e){var r=e.value,t=e.cursorPosition;null!==V.current&&(V.current.value=r,V.current.setSelectionRange(t,t))},R=(0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)((function(){return{setState:function(){if(V.current&&j.current&&E.current){var e=E.current.maskedValue,r=function(e,r){var t=e.added,n=e.beforeRange,a=e.afterRange,u=e.inputType,l=r.maskedValue,o=r.ast,c=r.replacement,i=r.separate,s=o.filter((function(e){var r=e.own;return i?"change"===r||"replacement"===r:"change"===r})),p=function(e){var r,t;return!1!==e&&null!==(t=null===(r=s[e])||void 0===r?void 0:r.index)&&void 0!==t?t:-1},v=p(!!t&&n.length+t.length-1),f=p(!!n&&n.length-1),h=p(!!a&&n.length+t.length);switch(u){case"insert":case"deleteForward":if(-1!==v)return v+1;if(-1!==h)return h;if(-1!==f)return f+1;break;case"deleteBackward":if(-1!==f)return f+1;if(-1!==h)return h}var m=d(l,c);return-1!==m?m:l.length}(j.current,E.current);M({value:e,cursorPosition:r})}},resetState:function(){var e,r;if(V.current&&j.current&&E.current){var t=(null===(r=null===(e=V.current._valueTracker)||void 0===e?void 0:e.getValue)||void 0===r?void 0:r.call(e))||"",n=d(t,E.current.replacement,S.current.start),a=-1!==n?n:t.length;M({value:t,cursorPosition:a})}}}}),[]),I=(0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((function(){var e,r,t,n,a;if(V.current&&j.current&&E.current){var u=j.current.unmaskedValue,l=k,o=g,c=w,s=b,p=null==m?void 0:m({unmaskedValue:u,mask:l,replacement:o,showMask:c,separate:s});p&&(u=null!==(e=p.unmaskedValue)&&void 0!==e?e:u,l=null!==(r=p.mask)&&void 0!==r?r:l,o=i(null!==(t=p.replacement)&&void 0!==t?t:o),c=null!==(n=p.showMask)&&void 0!==n?n:c,s=null!==(a=p.separate)&&void 0!==a?a:s),b||(u=u.split("").reduce((function(e,r){return Object.prototype.hasOwnProperty.call(g,r)?e:e+r}),"")),E.current=f({unmaskedValue:u,mask:l,replacement:o,showMask:c,separate:s}),R.setState();var d=new CustomEvent("masking",{bubbles:!0,cancelable:!1,composed:!0,detail:{unmaskedValue:u,maskedValue:E.current.maskedValue,pattern:E.current.pattern,isValid:E.current.isValid}});V.current.dispatchEvent(d),null==y||y(d)}}),[k,O,w,b,R,m,y]);return (0,react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect)((function(){var e;if(null!==V.current){var r=null!==(e=V.current._wrapperState)&&void 0!==e?e:{},t=r.controlled,n=void 0!==t&&t,a=r.initialValue,u=void 0===a?"":a;u=n?u:u||(w?k:"");var l=k.split("").reduce((function(e,r,t){if(Object.prototype.hasOwnProperty.call(g,r)){if(void 0!==u[t]&&u[t]!==r)return e+u[t];if(b)return e+r}return e}),"");j.current={unmaskedValue:l,beforeRange:"",added:"",afterRange:"",inputType:"initial"},E.current=f({initialValue:u,unmaskedValue:l,mask:k,replacement:g,showMask:w,separate:b}),R.setState()}}),[]),l=function(){var e,r,t;return{initialValue:null!==(t=null===(r=null===(e=V.current)||void 0===e?void 0:e._wrapperState)||void 0===r?void 0:r.initialValue)&&void 0!==t?t:"",mask:k,replacement:g}},(0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)((function(){var e=l(),r=e.initialValue,t=e.mask,n=e.replacement;if(false){ var o, a, u; }}),[]),(0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)((function(){P.current?P.current=!1:I()}),[k,O,w,b]),(0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)((function(){var e=function(e){var r,t,n,a,u,l,o;try{if(!(V.current&&j.current&&E.current))throw new h("The state has not been initialized.");if(S.current.cachedRequestID===S.current.requestID)throw new h("The input cursor has not been updated.");S.current.cachedRequestID=S.current.requestID;var c=null!==(n=null===(t=null===(r=V.current._valueTracker)||void 0===r?void 0:r.getValue)||void 0===t?void 0:t.call(r))&&void 0!==n?n:"",i=V.current.value,s=null!==(a=V.current.selectionStart)&&void 0!==a?a:0,d="";switch(s>S.current.start?d="insert":s<=S.current.start&&s<S.current.end?d="deleteBackward":s===S.current.end&&i.length<E.current.maskedValue.length&&(d="deleteForward"),E.current.maskedValue!==c&&(E.current=f({initialValue:c,unmaskedValue:"",mask:E.current.mask,replacement:E.current.replacement,showMask:E.current.showMask,separate:E.current.separate})),d){case"insert":var v=i.slice(S.current.start,s),m={start:S.current.start,end:S.current.end};if(j.current=p({maskingData:E.current,inputType:d,selectionRange:m,added:v}),!j.current.added)throw new h("The symbol does not match the value of the `replacement` object.");break;case"deleteBackward":case"deleteForward":m={start:s,end:s+(E.current.maskedValue.length-i.length)};j.current=p({maskingData:E.current,inputType:d,selectionRange:m,added:""});break;default:throw new h("The input type is undefined.")}I(),null===(o=null===(l=null===(u=V.current)||void 0===u?void 0:u._valueTracker)||void 0===l?void 0:l.setValue)||void 0===o||o.call(l,c),requestAnimationFrame((function(){var e;null===(e=V.current)||void 0===e||e.dispatchEvent(new Event("change",{bubbles:!0}))}))}catch(r){if(R.resetState(),e.preventDefault(),e.stopPropagation(),"SyntheticChangeError"!==r.name)throw r}},r=V.current;return null==r||r.addEventListener("input",e),function(){null==r||r.removeEventListener("input",e)}}),[R,I]),(0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)((function(){var e=function(){var e=function(){var r,t,n,a;S.current.start=null!==(t=null===(r=V.current)||void 0===r?void 0:r.selectionStart)&&void 0!==t?t:0,S.current.end=null!==(a=null===(n=V.current)||void 0===n?void 0:n.selectionEnd)&&void 0!==a?a:0,S.current.requestID=requestAnimationFrame(e)};S.current.requestID=requestAnimationFrame(e)};null!==V.current&&document.activeElement===V.current&&e();var r=V.current;return null==r||r.addEventListener("focus",e),function(){null==r||r.removeEventListener("focus",e)}}),[]),(0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)((function(){var e=function(){cancelAnimationFrame(S.current.requestID)},r=V.current;return null==r||r.addEventListener("blur",e),function(){null==r||r.removeEventListener("blur",e)}}),[]),V}var y=(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((function(r,t){var n=r.component,u=r.mask,l=r.replacement,o=r.showMask,i=r.separate,s=r.modify,p=r.onMasking,d=function(e,r){var t={};for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&r.indexOf(n)<0&&(t[n]=e[n]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var a=0;for(n=Object.getOwnPropertySymbols(e);a<n.length;a++)r.indexOf(n[a])<0&&Object.prototype.propertyIsEnumerable.call(e,n[a])&&(t[n[a]]=e[n[a]])}return t}(r,["component","mask","replacement","showMask","separate","modify","onMasking"]),v=m({mask:u,replacement:l,showMask:o,separate:i,modify:s,onMasking:p}),f=(0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((function(e){v.current=e,"function"==typeof t?t(e):"object"==typeof t&&null!==t&&(t.current=e)}),[t,v]);return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(n||"input",c({ref:f},d),void 0)}));


/***/ })

}]);